import type { ReactNode } from 'react';
import { cn } from '../lib/cn';

const WIDTHS = {
  /** Kolumna treści 1040 px (DESIGN §4). */
  default: 'max-w-[1104px]',
  /** Listy decyzji (Akceptacje): 880 px. */
  narrow: 'max-w-[944px]',
  /** Strony czytania: 720 px. */
  reading: 'max-w-[784px]',
} as const;

/**
 * Kontener strony: kolumna wyśrodkowana, odstęp od góry 48 px (desktop) i 24 px (mobile), na mobile
 * poziomo 16 px — treść jest w białych sekcjach z własnym paddingiem 16 px (przegląd Fali 9: przy 24 px lista na
 * 390 px miała 308 px i ucinała tytuły; wcześniej 24 px wg Figmy „Inbox / Mobile”, 3027:3040, sprzed sekcji).
 * Szerokości zawierają poziomy padding 32 px, więc treść ma dokładnie 1040 / 880 / 720 px.
 */
export function Page({
  width = 'default',
  children,
  className,
}: {
  width?: keyof typeof WIDTHS;
  children: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn('mx-auto w-full px-4 pt-6 pb-16 md:px-8 md:pt-12', WIDTHS[width], className)}>{children}</div>
  );
}
